'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var LineLogin_module = require('./LineLogin.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const LineLogin = ({
  url,
  featureName,
  layout
}) => {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    notificationCenterLineLoginButtonText
  } = nthHookTranslations.useTranslations();
  const handleLogin = e => {
    e.preventDefault();
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.LINE_SIGNUP,
      clickNotificationIsOptIn: true,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.LINE_SIGNUP,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER
    });

    // Make sure the event logged above fires off before executing the redirect
    nthHookContextAnalytics.flushAnalyticsQueueSync();
    window.location.href = url;
  };
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: isLandscape ? LineLogin_module["default"].containerLandscape : LineLogin_module["default"].container
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    className: LineLogin_module["default"].button,
    href: url,
    onClick: handleLogin
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    className: LineLogin_module["default"].icon,
    src: "https://assets.narvar.com/assets/line_login_icon.svg",
    alt: ""
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: LineLogin_module["default"].divider
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: LineLogin_module["default"].text
  }, notificationCenterLineLoginButtonText)));
};
var LineLogin$1 = nthHookTranslations.withTranslationsProvider(LineLogin, {
  translationKeys: ['notificationCenterLineLoginButtonText']
});

exports["default"] = LineLogin$1;
